export default {
  moduleLabelsCategories: (state) => state.moduleLabelsCategories,
  moduleLabelsCategoriesIsLoading: (state) =>
    state.moduleLabelsCategoriesIsLoading,
};
